import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@mui/material";
import theme from "./theme";

// Styles
import "./assets/css/app.css";

// Applications
import App from "./apps/App";
import LimitedSelectApp from "./apps/LimitedSelectApp";
import UserFormApp from "./apps/UserFormApp";

if (document.getElementById("cpv-search-id")) {
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>,
    document.getElementById("cpv-search-id")
  );
}
else if (document.getElementById("cpv-search-limited")) {
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <LimitedSelectApp />
    </ThemeProvider>,
    document.getElementById("cpv-search-limited")
  );
}
else if (document.getElementById("cpv-user-form-modal")) {
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <UserFormApp />
    </ThemeProvider>,
    document.getElementById("cpv-user-form-modal")
  );
}
